import { OnDestroy } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';
import { unsubscribe } from '@utils/object.utils';

import { Subscription } from 'rxjs';

export class UiMatDatepickerIntl extends MatDatepickerIntl implements OnDestroy {
    private _langChangeSub: Subscription;

    constructor(
        private _translateService: TranslateService,
        appState: AppStateFacade,
    ) {
        super();
        this._setLabels();
        this._langChangeSub = appState.language.change$
            .subscribe(() => this._setLabels());
    }

    ngOnDestroy() {
        unsubscribe(
            this._langChangeSub,
        );
    }

    private _setLabels() {
        this.calendarLabel = this._translateService.instant('calendar_label');
        this.openCalendarLabel = this._translateService.instant('open_calendar_label');
        this.prevMonthLabel = this._translateService.instant('previous_month_label');
        this.nextMonthLabel = this._translateService.instant('next_month_label');
        this.prevYearLabel = this._translateService.instant('previous_year_label');
        this.nextYearLabel = this._translateService.instant('next_year_label');
        this.prevMultiYearLabel = this._translateService.instant('previous_20_years_label');
        this.nextMultiYearLabel = this._translateService.instant('next_20_years_label');
        this.switchToMonthViewLabel = this._translateService.instant('choose_date_label');
        this.switchToMultiYearViewLabel = this._translateService.instant('choose_month_and_year_label');
        this.changes.next();
    }
}
